import { createClient } from '@supabase/supabase-js';

// These keys should ideally be in a .env file for a production React app,
// but for this implementation we are using the shared constants.
const SUPABASE_URL = 'https://ptimoshvdayhrasolhdy.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB0aW1vc2h2ZGF5aHJhc29saGR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEyMzk5OTIsImV4cCI6MjA4NjgxNTk5Mn0.7XTMrGkjgpPuW5yijpcx_0FmtZI-u488WOPmqR-dMqs';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
